export const measureTypeForm = (measureType, measureQuantity) => `${measureType}${measureType==='ml' ? '' : measureQuantity > 1 ? 's' : ''}`

export const leadTimeToText = (leadTime) => {
  const leadTimeScaleTag = leadTime[leadTime.length - 1];

  return {
    d: `${Number(leadTime.replace('d', ''))} dia${Number(leadTime.replace('d', '')) > 1 ? 's' : ''}`,
    h: `${Number(leadTime.replace('h', ''))} hora${Number(leadTime.replace('h', '')) > 1 ? 's' : ''}`,
  }[leadTimeScaleTag];
};

export const dataURLtoFile = (dataurl, filename) => {
    const arr = dataurl.split(',')
    const mime = arr[0].match(/:(.*?);/)[1]
    const extension = mime.split('/');
    const filenameWithMime = `${filename}.${extension[1]}`
    const bstr = atob(arr[1])
    let n = bstr.length
    const u8arr = new Uint8Array(n)
    while (n) {
      u8arr[n - 1] = bstr.charCodeAt(n - 1)
      n -= 1
    }
    return new File([u8arr], filenameWithMime, { type: mime })
  }